module.exports = __webpack_public_path__ + "static/media/benefits-header.e8270d00.png";